import React, { useEffect, useState } from "react";
import { Card, Container, Modal } from "react-bootstrap";
import { Button, Input } from "../../../components";
import {
  GetAllSystemNotificationTemplates,
  UpdateSystemNotificationTemplates,
} from "../../../utilities/api/system-notification-template";
import { toast } from "react-toastify";

const SystemNotification = () => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]) as any;
  const [edit, setEdit] = useState({}) as any;

  const handleClose = () => setShow(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    GetAllSystemNotificationTemplates()
      .then((res) => {
        setData(res?.data?.rows || []);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };



  const handleSubmit = async (
    id: string,
    message: string,
    isActive: string,
    useParameter: boolean = false
  ) => {
    const result = await UpdateSystemNotificationTemplates(
      useParameter ? id : edit?.id,
      {
        isActive: useParameter ? isActive : edit?.isActive,
      }
    );
    if (result?.status === 200) {
      toast.success(result?.data?.message);
      fetchData();
    } else {
      toast.error(result.response.data.message);
    }
    setEdit({});
    handleClose();
  };

  return (
    <>
      <Container fluid>
        <Card>
          <Card.Body>
            <Card.Title className="text-start mb-0">
              System Notification List
            </Card.Title>
            <hr />
            <table className="react-table text-start table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Event</th>
                  <th>Message</th>
                  <th>SMS Content</th>
                  <th>Send To</th>
                  <th>Sending Schedule</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.map?.((_notification: any, _index: any) => (
                  <tr key={_notification?.id}>
                    <td>{_index + 1}</td>
                    <td>{_notification?.templateName}</td>
                    <td>
                      {_notification?.message || "-"}
                    </td>
                    <td>{_notification?.smsContent || "-"}</td>
                    <td>{_notification?.sendToDescription}</td>
                    <td>{_notification?.templateTypeDescription}</td>
                    <td>
                      <div className="form-check form-switch">
                        <Input
                          type="checkbox"
                          id="custom-switch"
                          name="status"
                          className="form-check-input"
                          checked={_notification?.isActive}
                          onChange={() =>
                            handleSubmit(
                              _notification?.id,
                              _notification?.message,
                              `${!_notification?.isActive}`,
                              true
                            )
                          }
                        />
                        <label
                          title=""
                          htmlFor="custom-switch"
                          className="form-check-label"
                        ></label>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card.Body>
        </Card>
      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3 text-start">
            <label className="form-label">Type Message</label>
            <textarea
              className="form-control"
              value={edit?.message || ""}
              onChange={(e) =>
                setEdit((_oldVal: any) => ({
                  ..._oldVal,
                  message: e.target.value,
                }))
              }
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bname="Submit"
            id="submit"
            name="submit"
            className="btn btn-primary rounded-1"
            onClick={handleSubmit}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};
export { SystemNotification };
